__turbopack_context__.v({
  "button": "UiKitButton-module__1_I2na__button",
});
